import React from 'react'
import "./loading.css"

function Loading() {
  return (
<div className="ring">Loading
  <span className='sp'></span>
</div>
  )
}

export default Loading